const contacts = {
  instagram: {
    username: "creasnap.pku",
  },
  email: {
    username: "creasnappku@gmail.com",
  },
  telephone: {
    username: "6282173222564",
  },
  location: {
    address: "Jl. Tuanku Tambusai",
    subdistrict: " Kec. Binawidya",
    city: "Kota Pekanbaru",
    province: "Riau",
    postalCode: "28290",
  },
};

export default contacts;
